export enum LanguageName {
  hardware = '💻 Hardware',
  scratch = '🐱 Scratch',
  python = '🐍 Python',
  unity = 'Unity',
  java = 'Java  (coming soon!)',
  html = 'HTML',
  makecode = 'MakeCode',
}
